import React, { ReactElement } from 'react';
import './style.scss';
import { IconName, findIcon } from 'utils/handleIcon';
import { TwoSelections } from 'views/mutual/inputRadio';
import { CardLabel } from 'views/mutual/questionCard';
import { IconSize, SvgIcon } from 'views/mutual/svgIcon';
import { InputTemplate } from 'views/templates/module/inputTemplate';
import { DateInput, DateInputProps } from 'views/mutual/dateInput';

export const DateOfBirthQuestionTop = () => {
  const helpIcon = findIcon(IconName.help);
  const icon = findIcon(IconName.man);

  return (
    <>
      <div className="dateOfBirthQuestionTop">
        <CardLabel
          letter="&#10104; 生年月日"
          sentence='18歳未満の方は、口座開設をお受けできません。また、75歳以上の方は、審査結果によっては、口座開設をお受けできない場合がございます。'
        />
      </div>
    </>
  );
};

interface DateOfBirthQuestionBottomProps {
  dateProps: DateInputProps;
}

export const DateOfBirthQuestionBottom = (props: DateOfBirthQuestionBottomProps) => {
  return (
    <>
      <div className="dateOfBirthQuestionBottom">
        <DateInput placeholder={'年/月/日'} showYearMonthDropdown={true} {...props.dateProps} />
      </div>
    </>
  );
};
